import { forwardRef } from 'react';

import { TProps } from './types/TProps';

export const Button = forwardRef<HTMLButtonElement, TProps>(({ className, type = 'button', ...props }, ref) => (
  <button ref={ref} type={type} className={['btn', className].filter(Boolean).join(' ')} {...props} />
));

Button.displayName = 'Button';
